import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import AppHeader from "./AppHeader";
import DocumentHandler from "./DocumenHandler";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  debugLog,
  callApiText,
  logAccess,
  UIServerURL,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import ShareContentMessage from "./ShareContentMessage";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { FormatListBulletedOutlined } from "@material-ui/icons";

class DocContentDetail extends Component {
  constructor(props) {
    super(props);
    //this._HPEOnBackClick = this._HPEOnBackClick.bind(this);

    this.state = {
      DContent: this.props._docContent,
      bShowDoc: false,
      bDwnldDoc: false,
      bIsShared: false,
      SharedUrl: undefined,
      isFavourite: this.props._docContent.Content_IsFavorite,
      bLoadingFavUnFavHit: false,
      isFavUnFavdone: false,
    };
    this.sanitizedContentDescription =
      this.sanitizedContentDescription.bind(this);
    this._handleDocumentView = this._handleDocumentView.bind(this);
    this._CloseOverlay = this._CloseOverlay.bind(this);
    this._downloadPdf = this._downloadPdf.bind(this);
    this.OnShare = this.OnShare.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
    this.addToFavReqHandler = this.addToFavReqHandler.bind(this);
  }

  componentDidMount() {}
  /*   _HPEOnBackClick() {
    this.props.history.push("/");
  } */

  _hideShareContentPopUp() {
    this.setState({ SharedUrl: undefined, bIsShared: false });
    // this.props.hide();
  }

  addToFavReqHandler(contentRecord) {
    console.log("Favorite event fired!!");
    // event.stopPropagation();
    var endpoint = "/AllContent/AddorRemoveFavorites";
    var postData = {
      Favorite_ID: null,
      ContentId: contentRecord.Content_ID,
      Action_Type: contentRecord.Content_IsFavorite ? "Delete" : "Insert",
      Content_Type: contentRecord.Content_Type,
    };
    let token = auth.getToken();
    this.setState({ bLoadingFavUnFavHit: true });
    callApiPostJson(endpoint, postData, token).then((data) => {
      //console.log('EventAvailableEventTimes data:', data);
      if (data.Action_Type) {
        /*//This code reloads just the favorites piece.
             this.reloadFavorites();*/
        /*if(this.state.currentSearchObject)
             this._onSearchTextChange(this.state.currentSearchObject, this.state.currentSelectedSuggestion);
             else this.performInitialSearch();*/
        //contentRecord.Content_IsFavorite = true; //this refreshes contentrecord on display
        if (data.Action_Type === "Insert") {
          this.setState({
            isFavourite: true,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*  contentRecord.Content_IsFavorite = true;
                this.showSnack("Content added to My Favorites. Reloading..."); */
        } else {
          this.setState({
            isFavourite: false,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*                 contentRecord.Content_IsFavorite = false;
                this.showSnack("Content removed from My Favorites.  Reloading..."); */
        }
      }
    });
  }

  OnShare() {
    var lnk =
      UIServerURL +
      "?name=" +
      encodeURIComponent(this.props._docContent.Content_Title);
    this.setState({ SharedUrl: lnk, bIsShared: true });
  }

  _handleDocumentView() {
    this.setState({ bShowDoc: true });
  }

  _CloseOverlay() {
    this.setState({ bShowDoc: false });
  }

  _downloadPdf(contentRecord, event) {
    event.stopPropagation();
    var endpoint = "/DocContent/GetDocAccessToken/" + contentRecord.Content_ID;
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        var elem = window.document.createElement("a");
        elem.href = APIServerURL + "/DocContent/GetDocByToken/" + data.Token;
        elem.target = "_blank";
        elem.download =
          contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    });

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    logAccess(
      contentRecord.Content_ID,
      contentRecord.Content_Type,
      "DownloadDocument",
      this.props.calledBy,
      token
    );
  }

  sanitizedContentDescription(description) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  render() {
    var DCont = this.state.DContent
      ? this.state.DContent
      : this.props.props._docContent;

    var BShowDocument = this.state.bShowDoc;

    var Cont_Prods = "";

    if (this.state.DContent.Content_Products) {
      this.state.DContent.Content_Products.map((item) => {
        if (Cont_Prods !== "") {
          Cont_Prods = Cont_Prods + "," + item.ProductName;
        } else {
          Cont_Prods = item.ProductName;
        }
      });
    }

    var bIsTobeShared = this.state.bIsShared;
    var SharedLnk = this.state.SharedUrl;

    var IsCont_Favorite = this.state.isFavourite;

    var spinnercontent = "";
    if (this.state.bLoadingFavUnFavHit) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Updating your Favourites...</Text>
          </Box>
        </Layer>
      );
    }

    var Fav_UnFav_Done = this.state.isFavUnFavdone;

    return (
      <Layer full="true" position="center">
        {spinnercontent}
        {BShowDocument && (
          <DocumentHandler
            DocumentContentRecord={DCont}
            Document_ID={undefined}
            hide={this._CloseOverlay}
            calledBy={this.props.calledBy}
          />
        )}
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <AppHeader />

            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/* <Button label="Back" icon={<FormPrevious />} gap="xsmall" onClick={() => push("/home")} /> */}
                  <Box
                    align="center"
                    justify="between"
                    direction="row"
                    alignSelf="stretch"
                  >
                    <Box
                      align="center"
                      justify="center"
                      direction="row"
                      gap="xsmall"
                    >
                      <Heading margin="none">{DCont.Content_Title}</Heading>
                    </Box>
                    <Box align="center" justify="center" direction="row">
                      {/* <Button icon={<Like />} hoverIndicator />
                      <Button icon={<Dislike />} hoverIndicator /> */}
                      {IsCont_Favorite ? (
                        <Button
                          // icon={<FavoriteIcon style={{ color: "red" }} />}
                          icon={
                            <FavoriteIcon
                              color="secondary"
                              style={{ fontSize: 40 }}
                            />
                          }
                          // hoverIndicator
                          active={false}
                          disabled={Fav_UnFav_Done}
                          reverse={false}
                          secondary={false}
                          onClick={(contentRecord) => {
                            this.addToFavReqHandler(DCont);
                          }}
                          //primary
                        />
                      ) : (
                        <Button
                          icon={
                            <FavoriteBorderIcon
                              style={{ fontSize: 40, color: "green" }}
                            />
                          }
                          // hoverIndicator
                          active={false}
                          disabled={Fav_UnFav_Done}
                          reverse={false}
                          secondary={false}
                          onClick={(contentRecord) => {
                            this.addToFavReqHandler(DCont);
                          }}
                          //primary
                        />
                      )}
                    </Box>
                  </Box>
                </Header>
                <Box
                  align="stretch"
                  justify="between"
                  direction="row-responsive"
                  gap="medium"
                >
                  <Card pad="medium" flex="grow">
                    <Box align="center" justify="between" direction="row">
                      <Heading level="1" size="small" margin={{ top: "none" }}>
                        Description
                      </Heading>
                      <DropButton
                        dropAlign={{ top: "bottom" }}
                        dropContent={
                          <Box
                            align="start"
                            justify="start"
                            pad="medium"
                            name="dropContent"
                          >
                            <Grid columns={["small", "medium"]}>
                              <Text>Last Updated</Text>
                              <Text>
                                {DCont.Content_ModifiedDate
                                  ? new Date(
                                      DCont.Content_ModifiedDate
                                    ).toString()
                                  : new Date(
                                      DCont.Content_CreatedDate
                                    ).toString()}
                              </Text>
                              <Text>Author</Text>
                              <Text>{DCont.Content_Author}</Text>
                              <Text>Technical level</Text>
                              <Text>
                                {DCont.Content_ExpertiseLevel
                                  ? DCont.Content_ExpertiseLevel.ExpertLevelName
                                  : " No Expertise Tagged"}
                              </Text>
                              <Text>Products</Text>

                              <Paragraph
                                margin="xsmall"
                                size="small"
                                maxLines={2}
                              >
                                {Cont_Prods}
                              </Paragraph>

                              <Text>Keywords</Text>
                              <Paragraph margin="xsmall">
                                {DCont.Content_Keyword}
                              </Paragraph>
                            </Grid>
                          </Box>
                        }
                        icon={<More />}
                        secondary={false}
                      />
                    </Box>
                    <Paragraph margin={{ bottom: "none" }}>
                      {this.sanitizedContentDescription(
                        DCont.Content_Description
                      )}
                    </Paragraph>
                  </Card>
                </Box>
                {bIsTobeShared && SharedLnk && (
                  <ShareContentMessage
                    url={SharedLnk}
                    hide={this._hideShareContentPopUp}
                  />
                )}
                <Footer
                  align="center"
                  direction="row"
                  flex={false}
                  justify="end"
                  gap="medium"
                  margin={{ vertical: "small" }}
                >
                  <Button
                    label="Copy Url"
                    icon={<Link />}
                    secondary={false}
                    onClick={this.OnShare}
                  />
                  <Button
                    label="Download"
                    icon={<Download />}
                    secondary={false}
                    primary={false}
                    onClick={(event) => {
                      this._downloadPdf(DCont, event);
                    }}
                  />
                  <Button
                    label="View"
                    primary={false}
                    icon={<Inspect />}
                    secondary
                    onClick={this._handleDocumentView}
                  />
                </Footer>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}
export default DocContentDetail;
